import { FaLongArrowAltRight } from "react-icons/fa";
import styles from "./Section3.module.css";

const processPoints = [
  "Discovery & Strategy",
  "Wireframing & Prototyping",
  "Custom Design",
  "Development",
  "Content Development",
  "Testing & Refinement",
  "Launch & Post-Launch Support",
];

export default function Section3() {
  return (
    <section className={styles.section}>
      <div className={`container ${styles.shell}`}>
        <div className={styles.visualPanel}>
          <div className={styles.visualFrame}>
            <img
              src="/img/marketing/custom-web-developement.webp"
              alt="Website development showcase"
              className={styles.mainImage}
            />
          </div>
        </div>

        <div className={styles.contentPanel}>
          <h2>Custom Website Development</h2>
          <p className={styles.lead}>
            When off-the-shelf solutions don't cut it, our custom website
            development services deliver exactly what your business needs. We
            build bespoke websites from the ground up, ensuring every feature
            and design element is aligned with your vision. From sleek, modern
            designs to complex backend systems, we create powerful, scalable
            websites that grow with your business.
          </p>

          <div className={styles.pointsGrid}>
            {processPoints.map((point) => (
              <div key={point} className={styles.pointItem}>
                <FaLongArrowAltRight />
                <span>{point}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
